import React from 'react';
import { compose } from 'redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Core components
import DatePicker from 'components/core/DatePicker';
import TextField from 'components/core/TextField';
// Custom
import { entityDataShape } from 'constants/PropTypesShapes';
import { dateGenerator, dateFormatter } from 'utils/DateUtils';
import { buildFormErrors, dailyCodeConstraints } from 'utils/Forms';
import withFormManagement from 'hocs/WithFormManagement';
import EntitiesSelectField from 'installations/assets/entities/EntitiesSelectField';
import withEntitiesInformation from 'installations/assets/hocs/WithEntitiesInformation';

class DailyCodesAddForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const {
      hasMultipleEntities, defaultEntity, onFieldsChange, onRef,
    } = this.props;
    onRef(this);

    // Set default entity if user has onlyn one entity
    if (!hasMultipleEntities) {
      onFieldsChange({ entityId: defaultEntity.id });
    }
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: {
        entityId, begin, end, prefixLastname,
      },
      onErrorsChange, onValidate,
    } = this.props;

    const errors = buildFormErrors({
      entityId, begin, end, prefixLastname,
    }, dailyCodeConstraints);
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onValidate({
        entityId, begin, end, prefixLastname,
      });
      return true;
    }
    return false;
  }

  render() {
    const {
      fields: {
        entityId, begin, end, prefixLastname,
      }, errors,
      hasMultipleEntities, onFieldsChange, timezone,
    } = this.props;

    // Dates
    const beginDate = dateGenerator.dateFromTimezone(begin, timezone);
    const endDate = dateGenerator.dateFromTimezone(end, timezone);

    return (
      <div className="row">
        {hasMultipleEntities && (
          <div className="col-12">
            <EntitiesSelectField
              errorText={_get(errors, 'entityId')}
              value={entityId}
              onChange={(value) => onFieldsChange({ entityId: value })}
            />
          </div>
        )}
        <div className="col-12 col-md-4">
          <DatePicker
            label={<LocalizedMessage id="field.beginDate" />}
            value={beginDate}
            errorText={_get(errors, 'begin')}
            minDate={dateGenerator.now()}
            maxDate={endDate}
            onChange={(value) => onFieldsChange({ begin: dateFormatter.toServerFormatNoTime(value) })}
          />
        </div>
        <div className="col-12 col-md-4">
          <DatePicker
            label={<LocalizedMessage id="field.endDate" />}
            value={endDate}
            errorText={_get(errors, 'end')}
            minDate={beginDate}
            onChange={(value) => onFieldsChange({ end: dateFormatter.toServerFormatNoTime(value) })}
          />
        </div>
        <div className="col-12 col-md-4">
          <TextField
            label={<LocalizedMessage id="field.prefixLastname" />}
            errorText={_get(errors, 'prefixLastname')}
            value={prefixLastname}
            required
            onChange={(value) => onFieldsChange({ prefixLastname: value })}
          />
        </div>
      </div>
    );
  }
}

DailyCodesAddForm.propTypes = {
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
  hasMultipleEntities: PropTypes.bool.isRequired,
  defaultEntity: entityDataShape.isRequired,
  timezone: PropTypes.string.isRequired,
};

DailyCodesAddForm.defaultProps = {
  errors: null,
};

const mapFieldsToProps = {
  entityId: {
    defaultValue: null,
  },
  begin: {
    defaultValue: null,
  },
  end: {
    defaultValue: null,
  },
  prefixLastname: {
    defaultValue: '',
  },
};

module.exports = compose(
  withFormManagement(mapFieldsToProps, null, false),
  withEntitiesInformation,
)(DailyCodesAddForm);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/customers/DailyCodesAddForm.js